"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaltyThemeProvider = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const theme_1 = require("./theme");
const MaltyThemeProvider = ({ theme = 'global', children }) => {
    let selectedTheme;
    switch (theme) {
        case 'cadi':
            selectedTheme = theme_1.cadiTheme;
            break;
        case 'carlsberg':
            selectedTheme = theme_1.carlsbergTheme;
            break;
        case 'lbc':
            selectedTheme = theme_1.lbcTheme;
            break;
        default:
            selectedTheme = theme_1.globalTheme;
            break;
    }
    return react_1.default.createElement(styled_components_1.ThemeProvider, { theme: selectedTheme }, children);
};
exports.MaltyThemeProvider = MaltyThemeProvider;
//# sourceMappingURL=MaltyThemeProvider.js.map